import { useCallback, useState } from "react";
import { AccommodationListItem } from "../pages/AccommodationsPage/accommodationsSlice";

export type AccommodationSortOrder = "name" | "accommodationNumber";

const STORAGE_KEY = "accommodation-sort-order";
const DEFAULT_SORT_ORDER: AccommodationSortOrder = "name";

const isSortOrder = (value: string | null): value is AccommodationSortOrder =>
  value === "name" || value === "accommodationNumber";

/**
 * Kohdelistausten lajitteluvalinta. Valinta säilyy sivunvaihdon ja selaimen
 * uudelleenlatauksen yli, jotta käyttäjän ei tarvitse valita järjestystä
 * uudelleen joka kerta etusivulle tullessaan.
 */
export const useAccommodationSortOrder = (): [
  AccommodationSortOrder,
  (sortOrder: AccommodationSortOrder) => void,
] => {
  const [sortOrder, setStoredSortOrder] = useState<AccommodationSortOrder>(
    () => {
      const saved = localStorage.getItem(STORAGE_KEY);
      return isSortOrder(saved) ? saved : DEFAULT_SORT_ORDER;
    },
  );

  const setSortOrder = useCallback((value: AccommodationSortOrder) => {
    setStoredSortOrder(value);
    localStorage.setItem(STORAGE_KEY, value);
  }, []);

  return [sortOrder, setSortOrder];
};

/** Vertailufunktio kohteiden lajitteluun valitussa järjestyksessä. */
export const compareAccommodations =
  (sortOrder: AccommodationSortOrder) =>
  (a: AccommodationListItem, b: AccommodationListItem) =>
    sortOrder === "name"
      ? a.name.localeCompare(b.name)
      : Number(a.accommodationNumber) - Number(b.accommodationNumber);
